import React from 'react';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import IconButton from '@material-ui/core/IconButton';

import useTranslations from '../../hooks/useTranslations';
import SlimLineCard from '../containers/cards/SlimLineCard';
import styled from 'styled-components/macro';
import ActionsTooltip from '../ActionsTooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import Tooltip from '@material-ui/core/Tooltip';
import { Draggable } from 'react-beautiful-dnd';
import DeleteDialog from '../../internal-components/GeneralDialog';
import Animation from '../Animation';

const cardCSS = `
  margin-bottom: 1rem;

  h2 {
    margin: 0;
    margin-left: 0.8rem;
    font-size: 18px;
  }

  svg {
    color: #c8c8c8;
  }
`;

const CardColumn = styled.div`
  flex: 1;
`;

const PlusStatusesBlue = styled.div`
  color: #4c84ff;
`;

const FormBuilderBulkActionCardView = props => {
  const t = useTranslations();
  return (
    <>
      <Animation
        in={!props.isInDeleteSequence}
        onExited={props.onDelete}
        type="collapse"
      >
        <Draggable draggableId={props.id} index={props.position}>
          {provided => (
            <ActionsTooltip
              leaveDelay={0}
              buttons={[
                <Tooltip title="Edit">
                  <IconButton size="small" onClick={props.onEdit}>
                    <CreateIcon />
                  </IconButton>
                </Tooltip>,
                <Tooltip
                  title="Delete"
                  onClick={() => props.setIsDeleteDialogOpen(true)}
                >
                  <IconButton size="small">
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              ]}
            >
              <SlimLineCard
                $rounded
                $css={cardCSS}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <DragIndicatorIcon style={{ opacity: 1 }} />
                <CardColumn>{props.label}</CardColumn>
                <CardColumn>
                  {props.plusStatusesNumber ? (
                    <>
                      <div>Status: {props.statusesDisplay[0]}</div>
                      <Tooltip
                        arrow
                        title={
                          <div>
                            {props.statusesDisplay.map((status, index) => (
                              <div key={index}>{status}</div>
                            ))}
                          </div>
                        }
                      >
                        <PlusStatusesBlue>
                          {' '}
                          + {props.plusStatusesNumber} more
                        </PlusStatusesBlue>
                      </Tooltip>
                    </>
                  ) : (
                    <div>Status: {props.statusesDisplay[0]}</div>
                  )}
                </CardColumn>
                <CardColumn>
                  Change status to {props.updateValueDisplay}
                </CardColumn>
              </SlimLineCard>
            </ActionsTooltip>
          )}
        </Draggable>
      </Animation>
      <DeleteDialog
        open={props.isDeleteDialogOpen}
        title="bulkAction.delete.title"
        content="bulkAction.delete.msg"
        variant="delete"
        handleClose={() => props.setIsDeleteDialogOpen(false)}
        handleConfirm={() => {
          props.setIsDeleteDialogOpen(false);
          props.setIsInDeleteSequence(true);
        }}
      />
    </>
  );
};

export default FormBuilderBulkActionCardView;
